import React from 'react';
import { useVersionInfo } from '../../SettingsProvider/VersionInfoContext';
import './VersionInfo.css';

export const VersionInfo: React.FC = () => {
	const { versionInfo, isLoading } = useVersionInfo();
	const { version, release, copyrightYear, thirdPartyNoticesUrl } = versionInfo;

	const handleThirdPartyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		if (!thirdPartyNoticesUrl || thirdPartyNoticesUrl === '#') {
			e.preventDefault();
			// TODO: Implement third party notices navigation
			console.log('Third party notices clicked');
		}
	};

	if (isLoading) {
		return (
			<div className="version-info">
				<div className="version-text">Loading version info...</div>
			</div>
		);
	}

	return (
		<div className="version-info">
			<div className="version-text">
				Version: {version} ({release})
			</div>
			<div className="copyright-text">© {copyrightYear} Citrix Systems, Inc.</div>
			<div className="copyright-text">All Rights Reserved.</div>
			<a
				href={thirdPartyNoticesUrl}
				className="third-party-link"
				target="_blank"
				rel="noopener noreferrer"
				onClick={handleThirdPartyClick}
			>
				Citrix Third party notices
			</a>
		</div>
	);
};
